<template>
  <div class="ma-3">
    <div class="title mb-3">
      Sessions <v-icon>mdi-chevron-right</v-icon> Events settings management <v-icon>mdi-chevron-right</v-icon> {{ isNew ? 'New' : setting.name }}
    </div>

    <v-form
      ref="form"
      v-model="formValid"
      layout="column"
      layout-align="center center"
      @submit.prevent="save"
    >
      <div>
        <div class="title font-weight-light mb-3">
          Setting information
        </div>
        <v-text-field
          v-model="setting.name"
          outline
          label="Name"
          class="field-width"
          :rules="[ v => !!v || 'This field is required' ]"
        />
      </div>

      <v-btn
        depressed
        color="primary"
        @click="save"
      >
        Save
      </v-btn>
      <router-link
        :to="{name: 'admin-sessions-settings-index'}"
        class="grey--text"
      >
        Cancel
      </router-link>
    </v-form>
  </div>
</template>

<script>
    import Params from '@/api/params'

    export default {
        data () {
            return {
                setting: {
                    name: null
                },
                formValid: false
            }
        },
        computed: {
            isNew () {
                return this.$route.params.id === 'new';
            }
        },
        mounted () {
            if (!this.isNew) {
                this.fetch();
            }
        },
        methods: {
            fetch () {
                Params.get('events-settings', this.$route.params.id).then(res => {
                    this.setting = res.data;
                })
            },
            save () {
                if (!this.$refs.form.validate()) {
                    return;
                }

                if (this.isNew) {
                    Params.create('events-settings', this.setting).then(() => {
                        this.$router.push({name: 'admin-sessions-settings-index'});
                        this.$snotify.success(`The setting "${this.setting.name}" has been created`)
                    })
                } else {
                    Params.update('events-settings', this.setting.id, this.setting).then(() => {
                        this.$router.push({name: 'admin-sessions-settings-index'});
                        this.$snotify.success(`The setting "${this.setting.name}" has been updated`)
                    })
                }
            }
        }
    }
</script>